<script>
import { Contents } from 'tripod-styles/src/components/ContentsPlatform.store';
import HeaderPlan from './HeaderPlan.svelte';
import StaticLink  from 'tripod-styles/src/components/Buttons/StaticLink.svelte';
import {BuildIncludedServices} from './BuildIncludedServices';
import IncludedServices from './IncludedServices.svelte';
import allowed_included_services from './allowed_included_services';
import InfoIcon from 'tripod-styles/src/components/Elements/SpecialIcons/InfoIcon.svelte';


export let parsedPlans = [];
export let benefits_items = [];
export let has_products;
export let metadata;
export let interval;
export let SelectPlanInit;
export let select_plan_lang;
export let lang;
export let show_details;
export let set_value_benefit;
export let see_more_details;
export let close_details;

let many_benefits = false;
let membership_type = null;

/**
 * @type {HTMLElement}
*/
let card_benefits = null;

/**
 * @type {BuildIncludedServices}
 */
let additionals_instance = new BuildIncludedServices(()=> additionals_instance = additionals_instance);


$: {
    if(parsedPlans){
        many_benefits = false;
        parsedPlans.map((plan)=>{
            membership_type = plan.membership_type;
            if(allowed_included_services(membership_type)){
                additionals_instance.build_additional(plan);
            }
            if(many_benefits === true){return;}
            if(Object.values(plan.benefits).length > 6){
                many_benefits = true;
            }
        })
    }
}

// set width for left column on many benefits
let width_for_column = 0;
$: {
    if(card_benefits !== null){
        width_for_column = card_benefits.offsetWidth;
    }
}

</script>
<container-plans-selector class="columns pt-alt-4 mb-0">
    {#if parsedPlans.length > 0}
        <!-- white space start -->
        <card-plan class="column column-card-plan card-space-header pb-0">
            <section class="is-plan section-card padding-40"></section>
        </card-plan>
        <!-- white space ends -->
        {#each parsedPlans as plan}
            <HeaderPlan
                has_products={has_products}
                metadata={metadata}
                interval={interval}
                SelectPlanInit={SelectPlanInit}
                select_plan_lang={select_plan_lang}
                lang={lang}
                plan={plan}
            >

            </HeaderPlan>
        {/each}
    {/if}
</container-plans-selector>
<container-benefits class="columns is-centered">
    {#if parsedPlans.length > 0}
        <card-plan class="column column-card-plan card-space-content" bind:this={card_benefits}>
            <section class="is-plan section-card has-radius benefits-container-names">
                <div class="options-benefits is-grid" style="gap:19.6px !important;">
                    {#each Object.values(benefits_items) as benefit, key}
                        <h3 class="font-restricted-size-14 m-0 benefit-name {(key >= 6 && !show_details) ? "element-hiddable" : ""} is-flex is-align-items-center">
                            <span class="font-restricted-size-14 fw600 full-width" data-code={benefit.code_content}>
                                {Contents.get(benefit.code_content, Contents.search(benefit.name, window.lang_selected))}
                            </span>
                            {#if typeof benefit.info_ctn === "string" && benefit.info_ctn !== ""}
                                <span data-tooltip={Contents.get(benefit.info_ctn, Contents.search(benefit.info_ctn, window.lang_selected))} class="has-tooltip has-tooltip-multiline has-tooltip-right">
                                    <InfoIcon />
                                </span>
                            {/if}
                        </h3>
                    {/each}
                </div>
            </section>
        </card-plan>
        {#each parsedPlans as plan}
            <card-plan class="column column-card-plan card-plan-content container-plan-{plan.__id__}">
                <section class="{plan.is_recommended} {has_products ? 'has-products pt-0' : ""} subcontainer is-plan padding-40 has-radius">
                    <div class="values-benefits is-grid" style="gap:19.6px !important;">
                        {#each Object.values(plan.benefits).filter((item)=>{
                            if(item.hidden){
                                return false;
                            }

                            return item;
                        }) as benefit, key}
                            <h3 class="benefit-value m-0 has-text-centered is-flex {(key >= 6 && !show_details) ? "element-hiddable" : ""} is-align-items-center">
                                <span class="font-size-14 fw400 full-width">
                                    {@html set_value_benefit(benefit)}
                                </span>
                            </h3>
                        {/each}
                    </div>
                </section>
            </card-plan>
        {/each}
    {/if}
</container-benefits>
{#if parsedPlans.length > 0 && many_benefits}
    <div class="columns">
        <div class="column" style="max-width:{width_for_column}px;"></div>
        <div class="column">
            <div class="is-flex has-text-centered is-justify-content-center">
                <StaticLink class="has-text-primary" on:click={()=>{
                    show_details = !show_details ? true : false;
                }}>
                    {!show_details ? see_more_details : close_details}
                </StaticLink>
            </div>
        </div>
    </div>
{/if}
{#if parsedPlans.length > 0 && allowed_included_services(membership_type)}
    <IncludedServices
        membership_type={membership_type}
        parsedPlans={parsedPlans}
        additionals_instance={additionals_instance}
    />
{/if}
